import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76da1cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "boardState" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "상태 선택", -1))
const _hoisted_3 = { class: "board-state" }
const _hoisted_4 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_5 = ["onClick"]

import { ref } from 'vue';
interface stateOptionConfig {
  code: string;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardState',
  props: {
  stateOptions: {
    type: Array,
    required: true,
  },
},
  emits: ['setStateOption'],
  setup(__props, { emit }) {

const props = __props;



var isOn_state = ref(false);
var selectedOption = ref('상태');
/**** methods ----------------- */
const onClick_bg = () => {
  isOn_state.value = false;
};
const onClick_state = () => {
  isOn_state.value = true;
};
const onClick_stateOption = (item: stateOptionConfig) => {
  isOn_state.value = false;
  selectedOption.value = item.name;
  emit('setStateOption', item);
};
/**** content -----------------
 *
 * 상태 선택
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(isOn_state))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "selector-bg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_bg()))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["option-default", [{ on: _unref(isOn_state) === true }, { selected: _unref(selectedOption) !== '상태' }]]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_state()))
      }, _toDisplayString(_unref(selectedOption)), 3),
      _createVNode(_Transition, { name: "selectOption" }, {
        default: _withCtx(() => [
          (_unref(isOn_state))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.stateOptions, (item) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: "options",
                    key: item
                  }, [
                    _createElementVNode("li", {
                      class: "option-list",
                      onClick: ($event: any) => (onClick_stateOption(item))
                    }, _toDisplayString(item.name), 9, _hoisted_5)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})